//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const axios = require('axios');
const QRCode = require('qrcode');

export default {
  name: 'TalentCreator',
  layout: 'simple',
  data() {
    return {
      sid: null,
      textRows: 10,
      cvInput: '',
      placeholder: '',
      resultQrcode: false,
      qrCodeShow: false,
      caption: '',
      currentUrl: 'https://dev.step1ne.com/TalentCreator/',
      title: this.AITitle,
    };
  },
  async asyncData({ route, payload }) {
    const AITypeLabel = {
      '': '',
      智能履歷生成: 0,
      Linkedin履歷生成: 3,
      面試題目回答生成: 4,
      面試自我介紹: 2,
      自我推薦信生成: 5,
      求職信生成: 1,
      離職信生成: 6,
      求職約喝咖啡邀請信生成: 7,
    };
    const AITitle = `STEP1NE AI智能小工具 - ${route.params.type}`;
    const typeText = route.params.type;
    const typeValue = AITypeLabel[route.params.type];
    const url = `${process.env.domainUrl}/StepOneAI/AICreator/${typeText}`;
    return {
      AITitle,
      typeText,
      typeValue,
      url,
    };
  },
  head() {
    return {
      title: this.AITitle,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.AITitle,
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: this.url,
        },
        {
          hid: 'url',
          property: 'url',
          content: this.url,
        },
        {
          hid: 'description',
          name: 'description',
          content: `探索 ${this.AITitle} | AI智能小工具，專為企業和專業人士提供定制化的人工智能解決方案。`,
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: `探索 ${this.AITitle} | AI智能小工具，專為企業和專業人士提供定制化的人工智能解決方案。`,
        },
      ],
      link: [{ rel: 'canonical', href: this.url }],
    };
  },
  methods: {
    onClickCreate() {
      if (this.cvInput.trim().length < 20) {
        return this.$message.error('請充實您的內容!');
      }
      axios.post(`${process.env.SOCKET_API_URL}/chatAiTool/saveToCacheNoAuth`, {
        sid: this.sid,
        type: this.type,
        userInput: this.cvInput,
      });
      this.$alert('請先加入官方Line帳號好友，觀看結果', {
        confirmButtonText: '前往加入',
        showClose: false,
        callback: () => {
          this.onClickOk();
        },
      });
    },
    onClickOk() {
      this.url = `${process.env.LINE_LIFF_URL}?action=AITool&sid=${this.sid}&type=${this.typeValue}`;
      if (this.resultQrcode) {
        this.qrCodeShow = true;
        this.$nextTick(() => {
          var canvas = document.getElementById('qrcode');
          QRCode.toCanvas(canvas, this.url, function (error) {
            if (error) console.error(error);
            console.log('success!');
          });
        });
      } else {
        window.location.replace(this.url);
      }
    },
  },
  mounted() {
    if (sessionStorage.getItem('sid')) {
      this.sid = sessionStorage.getItem('sid');
    } else {
      this.sid = Math.floor(Math.random() * 9999999999);
      sessionStorage.setItem('sid', this.sid);
    }

    if (this.typeValue != '6')
      this.caption = `<p>◆過往經歷、專業技能、證照、學校</p><p style="padding-left: 20px;">背景等(簡述、調列式等，都可以 !)</p><p>您也可以…</p><p>◆從現有的履歷，複製文字貼上內容</p>`;
    this.$nextTick(() => {
      if (process.browser) {
        if (typeof window !== 'undefined') {
          setTimeout(() => {
            if (typeof window.FB !== 'undefined') {
              let fb = document.querySelector('#fb-root');
              if (fb) {
                fb.style.display = 'none';
              }
            }
          }, 1000);
        }
        let vh = document.documentElement.clientHeight;
        this.textRows = Math.floor((vh - 250) / 45);
        let vw = document.documentElement.clientWidth;
        if (vw > 768) {
          this.resultQrcode = true;
        }
        axios
          .post(
            `${process.env.SOCKET_API_URL}/chatAiTool/getPlaceholderNoAuth`,
            {
              type: this.typeValue,
            },
          )
          .then(({ data }) => {
            this.placeholder = data.data.placeholder;
          });
      }
    });
  },
};
